import { SupportHL7Message, formatDate, JsonDiffReact } from '@enter/core';
import * as S from './claim-timeline-table.styles';
import React from 'react';

interface IHL7MessageDetailProps {
    hl7Message: SupportHL7Message;
    before?: SupportHL7Message;
}
const prettyJson = (text: string) => {
    try {
      return JSON.stringify(JSON.parse(text), null, 2);
    } catch {
      return text;
    }
  };
export const HL7MessageDetail: React.FunctionComponent<IHL7MessageDetailProps> = (
    props: IHL7MessageDetailProps,
): React.ReactElement => {
    const { hl7Message, before } = props;
    const afterMessage = prettyJson(hl7Message.message || '').replace(/\r|\n/g, '\n');
    const beforeMessage = prettyJson(before?.message || '').replace(/\r|\n/g, '\n');
    const showDiff = !!before;

    const renderCreated = (): string => {
        if (!hl7Message.created) {
            return '—';
        }

        try {
            return formatDate(hl7Message.created, 'MMM dd, yyyy HH:mm');
        } catch (error) {
            return '—';
        }
    };

    return (
        <S.ExpandContainer>
            <S.ExpandTable>
                <S.ExpandTBody>
                    <S.ExpandTR>
                        <S.ExpandTH>ID</S.ExpandTH>
                        <S.ExpandTD>{hl7Message.id || '—'}</S.ExpandTD>
                    </S.ExpandTR>
                    <S.ExpandTR>
                        <S.ExpandTH>Type</S.ExpandTH>
                        <S.ExpandTD>{hl7Message.type || '—'}</S.ExpandTD>
                    </S.ExpandTR>
                    <S.ExpandTR>
                        <S.ExpandTH>Created</S.ExpandTH>
                        <S.ExpandTD>{renderCreated()}</S.ExpandTD>
                    </S.ExpandTR>
                    {!showDiff && (
                        <S.ExpandTR>
                        <S.ExpandTH>Payload</S.ExpandTH>
                        <S.ExpandTD>
                        <S.PayloadWrapper>
                                <pre>{ afterMessage ?  afterMessage : '—'}</pre>
                            </S.PayloadWrapper>
                        </S.ExpandTD>
                    </S.ExpandTR>
                    )}
                    {showDiff && ( 
                        <S.ExpandTR>
                            <S.ExpandTD colSpan={2}>
                                <table style={{ width: '100%' }}>
                                    <tbody>
                                        <tr>
                                            <td>Before</td>
                                            <td>After</td>
                                            <td>Diff</td>
                                        </tr>
                                        <tr>
                                            <td style={{ verticalAlign: 'top', fontSize: '12px', fontFamily: "'Bitstream Vera Sans Mono', 'DejaVu Sans Mono', Monaco, Courier, monospace" }}>
                                                <pre>{beforeMessage ? beforeMessage : ''}</pre>
                                            </td>
                                            <td style={{ verticalAlign: 'top', fontSize: '12px', fontFamily: "'Bitstream Vera Sans Mono', 'DejaVu Sans Mono', Monaco, Courier, monospace" }}>
                                                <pre>{afterMessage ? afterMessage : ''}</pre>
                                            </td>
                                            <td style={{ verticalAlign: 'top' }}>
                                                <JsonDiffReact
                                                    right={afterMessage}
                                                    left={beforeMessage}
                                                    show={false}
                                                    annotated={false}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </S.ExpandTD>
                        </S.ExpandTR>
                    )}
                </S.ExpandTBody>
            </S.ExpandTable>
        </S.ExpandContainer>
    );
};
